export const getPaddingBasedOnSize = (
    areaStr: string | undefined
): number[] => {
    if (!areaStr) {
        throw new Error("Invalid input: not a number");
    }

    const area = parseFloat(areaStr);

    if (Number.isNaN(area)) {
        throw new Error("Invalid input: not a number");
    }

    if (area >= 60000) {
        return [100, 100, 100, 100];
    }
    if (area >= 20000 && area < 60000) {
        return [180, 180, 180, 180];
    }
    if (area >= 15000) {
        return [180, 180, 180, 180];
    }
    if (area >= 10000 && area < 15000) {
        return [180, 180, 180, 180];
    }
    if (area >= 1000 && area < 10000) {
        return [150, 150, 150, 150];
    }
    return [265, 260, 260, 260];
};
